import {Routes} from '@angular/router';
import {AppointmentsPreselectionComponent} from './page/appointments-preselection/appointments-preselection.component';
import {AppointmentsCalendarComponent} from './page/appointments-calendar/appointments-calendar.component';
import {AppointmentsPatientComponent} from './page/appointments-patient/appointments-patient.component';
import {AppointmentsVerificationComponent} from './page/appointments-verification/appointments-verification.component';
import {AppointmentsSuccessComponent} from './page/appointments-success/appointments-success.component';
import {NotFoundComponent} from './common/component/not-found/not-found.component';
import {AppointmentsFlowGuard} from './common/guards/appointments-flow.guard';
import {FlowStep} from './common/model/flow-step';
import {LicenseComponent} from './page/legal/license/license.component';

export const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'vorauswahl'},
  {
    path: 'vorauswahl',
    component: AppointmentsPreselectionComponent
  },
  {
    path: 'kalender',
    component: AppointmentsCalendarComponent,
    canActivate: [AppointmentsFlowGuard],
    data: {requiredStep: FlowStep.Preselection}
  },
  {
    path: 'patient',
    component: AppointmentsPatientComponent,
    canActivate: [AppointmentsFlowGuard],
    data: {requiredStep: FlowStep.Calendar}
  },
  {
    path: 'verifizierung',
    component: AppointmentsVerificationComponent,
    canActivate: [AppointmentsFlowGuard],
    data: {requiredStep: FlowStep.PatientData}
  },
  {
    path: 'erfolg',
    component: AppointmentsSuccessComponent,
    canActivate: [AppointmentsFlowGuard],
    data: {requiredStep: FlowStep.Verification}
  },
  {path: 'license', component: LicenseComponent},
  {path: '**', component: NotFoundComponent}
];
